import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import  * as solidIcons  from '@fortawesome/free-solid-svg-icons'
import  * as regularIcons  from '@fortawesome/free-regular-svg-icons'
import  * as brandsIcons  from '@fortawesome/free-brands-svg-icons'

export default class ResellerSettingsMenuComponent extends Component {
  render () {    

    //console.log("history",this.props.history.location.pathname)

    var pathname = this.props.history.location.pathname

    return (
      <div className="row">
        <div className="pull-left" style={{ marginLeft: "1em" , marginRight: "1em" , marginTop: "0.5em" }}>
          <NavLink to={'/reseller/settings/'} className={ pathname == '/reseller/settings' ? "selectedMainBtn" : "mainBtn" } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faGear} /><span className="hidden-xs hidden-sm">&nbsp;&nbsp;Generali</span>
          </NavLink>          
          <NavLink to={'/reseller/settings/adminUsers'} className={ pathname == '/reseller/settings/adminUsers' ? "selectedMainBtn" : "mainBtn"  } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faUserAstronaut} /><span className="hidden-xs hidden-sm">&nbsp;&nbsp;Utenti admin</span>
          </NavLink>
          <NavLink to={'/reseller/settings/areas'} className={ pathname == '/reseller/settings/areas' ? "selectedMainBtn" : "mainBtn"  } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faTableCells} /><span className="hidden-xs hidden-sm">&nbsp;&nbsp;Zone</span>
          </NavLink>
          <NavLink to={'/reseller/settings/categories'} className={ pathname == '/reseller/settings/categories' ? "selectedMainBtn" : "mainBtn"  } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faShapes} /><span className="hidden-xs hidden-sm">&nbsp;&nbsp;Categorie</span>
          </NavLink>          
          <NavLink to={'/reseller/settings/documentTypes'} className={ pathname == '/reseller/settings/documentTypes' ? "selectedMainBtn" : "mainBtn"  } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faFileContract} /><span className="hidden-xs hidden-sm">&nbsp;&nbsp;Documenti</span>
          </NavLink>
          <NavLink to={'/reseller/settings/vehicles'} className={ pathname == '/reseller/settings/vehicles' ? "selectedMainBtn" : "mainBtn"  } >
            <FontAwesomeIcon  size="1x" icon={solidIcons.faCar} /><span className="hidden-xs hidden-sm">&nbsp;&nbsp;Veicoli</span>
          </NavLink>
          <NavLink to={'/reseller/settings/markTypes'} className={ pathname == '/reseller/settings/markTypes' ? "selectedMainBtn" : "mainBtn"  }>
            <FontAwesomeIcon  size="1x" icon={solidIcons.faWallet} /><span className="hidden-xs hidden-sm">&nbsp;&nbsp;Permessi</span>
          </NavLink>
        </div>
      </div>
    )
  }
}
